(() => {
  const origin = 'https://eclipse-studio-production.up.railway.app';
  const validId = id => typeof id === 'string' && /^[a-f0-9]{48}$/.test(id);
  for (const section of document.querySelectorAll('[data-ae-studio]')) {
    if (section.dataset.initialized) continue;
    section.dataset.initialized = 'true';
    const dialog = section.querySelector('[data-studio-dialog]');
    const frame = section.querySelector('[data-studio-frame]');
    const status = section.querySelector('[data-studio-status]');
    const fallback = section.querySelector('[data-studio-fallback]');
    const initialId = new URL(location.href).searchParams.get('design');
    let loaded = false, ready = false, timer, previousOverflow = '', opener = null;
    const send = type => frame.contentWindow?.postMessage({channel:'ae-studio-v1',type},origin);
    function open(event) {
      if (!dialog.showModal) return;
      event?.preventDefault();
      if (dialog.open) return;
      opener = event?.currentTarget || document.activeElement;
      previousOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      dialog.showModal();
      if (!loaded) {
        loaded = true;
        const src = new URL('/', origin);
        src.searchParams.set('embed','shopify');
        if (validId(initialId)) src.searchParams.set('design',initialId);
        frame.src = src.href;
        timer = setTimeout(() => { if (!ready) { status.firstChild.textContent=status.dataset.failed+' ';status.hidden=false; } },20000);
      } else send('init');
    }
    frame.addEventListener('load', () => send('init'));
    window.addEventListener('message', event => {
      if (event.origin !== origin || event.source !== frame.contentWindow || event.data?.channel !== 'ae-studio-v1') return;
      if (event.data.type === 'ready') { ready=true;clearTimeout(timer);status.hidden=true; }
      if (event.data.type === 'design' && validId(event.data.id)) {
        const url = new URL(location.href);
        url.searchParams.set('design',event.data.id);
        window.history.replaceState(null,'',url);
        fallback.href=origin+'/?design='+event.data.id;
      }
    });
    section.querySelector('[data-studio-open]').addEventListener('click',open);
    document.querySelectorAll('a[href="#design-studio"]').forEach(a=>a.addEventListener('click',open));
    section.querySelector('[data-studio-close]').addEventListener('click',()=>dialog.close());
    dialog.addEventListener('close',()=>{send('hide');document.documentElement.style.overflow=previousOverflow;opener?.focus?.({preventScroll:true});});
    if (validId(initialId)) {fallback.href=origin+'/?design='+initialId;open();}
  }
})();

